/**
 * Adding somebody who is not staff but has a tab: a regular who settles
 * weekly, the shop next door. A name, and a number if they have one. Nothing
 * else — they get no login.
 */
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import { api } from '../../lib/api.js';
import { Button } from '../../components/ui/Button.jsx';
import { Field } from '../../components/ui/Field.jsx';

export function AccountHolderSheet({ person = null, onClose, onDone }) {
  const [name, setName] = useState(person ? `${person.first_name} ${person.last_name}`.trim() : '');
  const [phone, setPhone] = useState(person?.phone ?? '');

  const save = useMutation({
    mutationFn: (body) => (person ? api.put(`/admin/account-holders/${person.id}`, body) : api.post('/admin/account-holders', body)),
    onSuccess: onDone,
  });
  const valid = name.trim().length >= 2;

  return (
    <div role="dialog" aria-modal="true" aria-label={person ? 'Edit account holder' : 'Add an account holder'} className="fixed inset-0 z-30 flex items-start justify-center overflow-y-auto bg-black/70 p-4">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (valid) save.mutate({ name: name.trim(), ...(phone.trim() ? { phone: phone.trim() } : {}) });
        }}
        className="mt-10 w-full max-w-md rounded-2xl bg-surface p-5"
      >
        <h2 className="font-semibold text-lg text-ink">{person ? 'Edit account holder' : 'Add an account holder'}</h2>
        <p className="mt-1 text-sm text-ink-2">Somebody who is not staff but runs a tab here. Bills go on their account at the till and are cleared from the Staff screen. They cannot sign in.</p>

        <div className="mt-4 space-y-3">
          <Field label="Name" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Bashir Traders" autoFocus />
          <Field label="Phone (optional)" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="0300 1234567" inputMode="tel" />
        </div>

        {save.isError && (
          <p role="alert" className="mt-3 rounded-lg bg-bad-bg px-3 py-2 text-sm text-bad">
            {save.error?.message || 'Could not save.'}
          </p>
        )}

        <div className="mt-5 flex gap-2">
          <Button variant="secondary" className="flex-1" onClick={onClose} disabled={save.isPending}>
            Cancel
          </Button>
          <Button type="submit" className="flex-1" busy={save.isPending} disabled={!valid}>
            {person ? 'Save' : 'Add account holder'}
          </Button>
        </div>
      </form>
    </div>
  );
}
